import { format, parseISO, startOfDay } from 'date-fns'

export const toIsoDate = (input: string): string => {
	const [day, month, year] = input.split('.')
	return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export const fromIsoDate = (input: string): string => {
	const [year, month, day] = input.split('-')
	return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`
}

export function formatGerman(isoString: string): string {
	const d = parseISO(isoString)
	const datePart = format(d, 'dd.MM.yyyy')
	const timePart = format(d, 'HH:mm')
	return `${datePart} um ${timePart} Uhr`
}

export const parseGerman = (s: string) => {
	const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
	if (!m) return null
	const [_, day, mon, year] = m.map(Number)
	return startOfDay(new Date(year, mon - 1, day))
}

export const now = new Date()
export const todayMidnight = startOfDay(now)
export const stripHtml = (html = '') => html.replace(/<[^>]*>/g, '')

export const isValidDate = (s: string): boolean => {
	const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
	if (!m) return false

	const day = parseInt(m[1], 10)
	const month = parseInt(m[2], 10)
	const year = parseInt(m[3], 10)

	const nowYear = new Date().getFullYear()
	if (year < nowYear - 100 || year > nowYear + 100) return false

	const d = new Date(year, month - 1, day)
	return (
		d.getFullYear() === year &&
		d.getMonth() === month - 1 &&
		d.getDate() === day
	)
}
